/* Skapad av Claude Code — Slow feeder bundle picker · 2026-09-13.
   Läser trappan (antal:procent) och priserna (ören, i korgens valuta) ur markupen,
   räknar allt live och skickar valda färger via /cart/add.js:
   - totalt antal skålar (Wave + Bloom ihop) styr vilket trappsteg som är aktivt
   - trappstegets styckpris = referensprodukten (PDP:n) × (1 − procent), avrundat
   - färgrutans pris = variantens pris × (1 − procent för NÄSTA steg) = "lägg till
     den här → så här mycket kostar den" (Eriks mockup: 1 vald → rutorna visar 169 kr)
   - köpknappen = summan av valda × (1 − aktivt steg), struket ordinarie vid rabatt
   - ingen skål förvald; > 1 skål → alla skålrader stämplas _godispaket (Paket-motorn drar rabatten i kassan),
     1 skål → vanlig rad utan stämpel
   - TILLBEHÖR (rutor med data-acc): egen fast procent (data-acc-pct) som gäller när minst
     en skål är vald; räknas aldrig i skåltrappan; stämplas _slowfeeder_tillbehor (egen
     Paket-motor-regel med stämpel Tillbehör). Spara-raden under knappen = struket − pris.
   Bekräftelse efter köp: UpCart → SvdNotis (fångar /cart/add själv) → temats drawer → /cart. */
(function () {
  'use strict';

  var PROPERTY_KEY = '_godispaket';
  var ACC_PROPERTY_KEY = '_slowfeeder_tillbehor';

  function hasUpCart() {
    return !!(window.upcart || document.querySelector('[id*="upcart" i], [class*="upcart" i]'));
  }
  function tryOpenUpCart() {
    try {
      if (window.upcart && typeof window.upcart.openCart === 'function') { window.upcart.openCart(); return; }
      if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
    } catch (e) { /* UpCart öppnar normalt själv */ }
  }
  var DRAWER_SECTIONS = [
    { id: 'Cart-Drawer',        section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];
  function sectionInnerHTML(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }
  function renderDrawerSections(response) {
    if (!response || !response.sections) return;
    DRAWER_SECTIONS.forEach(function (s) {
      var host = document.getElementById(s.id);
      var html = response.sections[s.section];
      if (!host || !html) return;
      var target = host.querySelector(s.selector) || host;
      var inner = sectionInnerHTML(html, s.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    if (typeof window.CartDrawer !== 'undefined') { new window.CartDrawer(); }
  }
  function openThemeCartDrawer(response) {
    var drawerEl = document.getElementById('Cart-Drawer');
    if (!drawerEl) return false;
    renderDrawerSections(response);
    document.body.classList.add('open-cc');
    drawerEl.classList.add('active');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    return true;
  }

  function initPicker(root) {
    if (root.dataset.sfBound) return;
    root.dataset.sfBound = '1';

    // ---------- Valuta ----------
    var currency = root.getAttribute('data-currency') || 'SEK';
    var fmt = null;
    if (currency !== 'SEK' && window.Intl && Intl.NumberFormat) {
      try { fmt = new Intl.NumberFormat(root.getAttribute('data-locale') || 'sv', { style: 'currency', currency: currency, maximumFractionDigits: 2 }); } catch (e) { fmt = null; }
    }
    // exact=true → hela beloppet med ören när det inte är jämnt (köpknappen ska stämma på öret
    // med kassan: 2 × 199 × 0,85 = 338,30 kr). Styckpriser i trappan/rutorna avrundas till hela kr.
    function money(cents, exact) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      if (fmt) return fmt.format(cents / 100);
      if (exact && cents % 100 !== 0) return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
      return Math.round(cents / 100).toString() + ' kr';
    }
    function discounted(cents, pct) {
      // Avrundas till hela ören så 199,00 × 0,85 = 169,15 → visas som "169 kr" (SEK rundar till hela kr).
      return Math.round(cents * (100 - pct) / 100);
    }

    // ---------- Trappan ----------
    var tiers = (root.getAttribute('data-tiers') || '1:0').split('|').map(function (t) {
      var p = t.split(':');
      return { min: parseInt(p[0], 10) || 1, pct: parseInt(p[1], 10) || 0 };
    }).sort(function (a, b) { return a.min - b.min; });
    function tierFor(n) {
      var t = tiers[0];
      tiers.forEach(function (x) { if (n >= x.min) t = x; });
      return t;
    }
    var refPrice = parseInt(root.getAttribute('data-ref-price'), 10) || 0;
    var tierEls = Array.prototype.slice.call(root.querySelectorAll('[data-sf-tier]'));

    // ---------- Texter ----------
    var T = {
      valdS: root.getAttribute('data-t-vald-s') || '[antal] [enhet] vald',
      valdP: root.getAttribute('data-t-vald-p') || '[antal] [enhet] valda',
      ingenVald: root.getAttribute('data-t-ingen-vald') || 'Välj din skål',
      enhetS: root.getAttribute('data-t-enhet-s') || 'skål',
      enhetP: root.getAttribute('data-t-enhet-p') || 'skålar',
      perSt: root.getAttribute('data-t-per-st') || '/st',
      knapp: root.getAttribute('data-t-knapp') || 'Lägg till i varukorgen',
      knappLaddar: root.getAttribute('data-t-knapp-laddar') || 'Lägger till…',
      spara: root.getAttribute('data-t-spara-text') || ''
    };
    var accPct = parseInt(root.getAttribute('data-acc-pct'), 10) || 0;

    // ---------- Element ----------
    var allTiles = Array.prototype.slice.call(root.querySelectorAll('[data-sf-tile]'));
    var tiles = allTiles.filter(function (t) { return !t.hasAttribute('data-acc'); });   // skålar
    var accTiles = allTiles.filter(function (t) { return t.hasAttribute('data-acc'); }); // tillbehör
    var countEl = root.querySelector('[data-sf-count]');
    var cta = root.querySelector('[data-sf-cta]');
    var ctaLabel = root.querySelector('[data-sf-cta-label]');
    var ctaNow = root.querySelector('[data-sf-cta-now]');
    var ctaWas = root.querySelector('[data-sf-cta-was]');
    var errEl = root.querySelector('[data-sf-error]');
    var saveEl = root.querySelector('[data-sf-save]');
    var processing = false;
    var lastTierMin = null;

    function qty(tile) { return parseInt(tile.getAttribute('data-qty'), 10) || 0; }
    function price(tile) { return parseInt(tile.getAttribute('data-price'), 10) || 0; }
    function maxOf(tile) { return parseInt(tile.getAttribute('data-max'), 10) || 0; } // 0 = obegränsat
    function available(tile) { return tile.getAttribute('data-available') === 'true'; }
    function setQty(tile, n) {
      n = Math.max(0, n);
      var max = maxOf(tile);
      if (max > 0 && n > max) n = max;
      tile.setAttribute('data-qty', String(n));
      tile.classList.toggle('is-selected', n > 0);
      var q = tile.querySelector('[data-sf-qty]');
      if (q) q.textContent = String(n);
      var plus = tile.querySelector('[data-sf-plus]');
      if (plus) plus.disabled = (max > 0 && n >= max);
    }
    function total() { return tiles.reduce(function (s, t) { return s + qty(t); }, 0); }
    function subtotal() { return tiles.reduce(function (s, t) { return s + qty(t) * price(t); }, 0); }
    function accTotal() { return accTiles.reduce(function (s, t) { return s + qty(t); }, 0); }
    function accSubtotal() { return accTiles.reduce(function (s, t) { return s + qty(t) * price(t); }, 0); }

    // ---------- Rendering ----------
    function render() {
      var n = total();
      var tier = tierFor(Math.max(n, 1));
      var next = tierFor(n + 1);

      // Räknaren
      if (countEl) {
        var tpl = n === 1 ? T.valdS : T.valdP;
        countEl.textContent = n === 0 ? T.ingenVald : tpl.replace('[antal]', String(n)).replace('[enhet]', n === 1 ? T.enhetS : T.enhetP);
      }

      // Trappan: aktivt steg + styckpris per steg (referens = PDP-produktens pris)
      tierEls.forEach(function (el) {
        var min = parseInt(el.getAttribute('data-min'), 10) || 1;
        var pct = parseInt(el.getAttribute('data-pct'), 10) || 0;
        var active = min === tier.min && n > 0;
        el.classList.toggle('is-active', active);
        el.setAttribute('aria-current', active ? 'true' : 'false');
        var pe = el.querySelector('[data-sf-tier-price]');
        if (pe && refPrice) pe.textContent = money(discounted(refPrice, pct)) + T.perSt;
        if (active && lastTierMin !== null && lastTierMin !== min) {
          el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
        }
      });
      lastTierMin = n > 0 ? tier.min : null;

      // Färgrutorna: priset om man lägger till EN till (nästa steg)
      tiles.forEach(function (tile) {
        if (!available(tile)) return;
        var p = price(tile);
        var nowEl = tile.querySelector('[data-sf-tile-now]');
        var wasEl = tile.querySelector('[data-sf-tile-was]');
        if (nowEl) nowEl.textContent = money(discounted(p, next.pct));
        if (wasEl) wasEl.textContent = next.pct > 0 ? money(p) : '';
      });

      // Tillbehören: fast procent när minst en skål är vald, annars fullpris
      var accP = n > 0 ? accPct : 0;
      accTiles.forEach(function (tile) {
        var p = price(tile);
        var nowEl = tile.querySelector('[data-sf-tile-now]');
        var wasEl = tile.querySelector('[data-sf-tile-was]');
        if (nowEl) nowEl.textContent = money(discounted(p, accP));
        if (wasEl) wasEl.textContent = accP > 0 ? money(p) : '';
      });

      // Köpknappen: skålar × trappsteg + tillbehör × tillbehörsprocent
      var sub = subtotal();
      var accSub = accSubtotal();
      var now = discounted(sub, tier.pct) + discounted(accSub, accP);
      var full = sub + accSub;
      if (ctaNow) ctaNow.textContent = n > 0 ? money(now, true) : '';
      if (ctaWas) ctaWas.textContent = (n > 0 && full > now) ? money(full, true) : '';
      if (cta) cta.disabled = n === 0 || processing;
      if (saveEl) {
        var saved = full - now;
        if (n > 0 && saved > 0 && T.spara) { saveEl.textContent = T.spara.replace('[belopp]', money(saved, true)); saveEl.hidden = false; }
        else { saveEl.hidden = true; }
      }
      root.dispatchEvent(new CustomEvent('svd-sf:change', { detail: { total: n, pct: tier.pct, subtotal: sub, accessories: accTotal(), accSubtotal: accSub, price: now } }));
    }

    // ---------- Interaktion ----------
    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-sf-tile]');
      if (!tile || !root.contains(tile) || !available(tile)) return;
      if (e.target.closest('[data-sf-add]')) { setQty(tile, qty(tile) + 1); render(); return; }
      if (e.target.closest('[data-sf-plus]')) { setQty(tile, qty(tile) + 1); render(); return; }
      if (e.target.closest('[data-sf-minus]')) { setQty(tile, qty(tile) - 1); render(); return; }
      if (e.target.closest('.svd-sf__tile-img')) {
        // Klick på bilden: välj (1 st) om ovald — annars gör inget (steppern sköter antalet)
        if (qty(tile) === 0) { setQty(tile, 1); render(); }
      }
    });

    // ---------- Köp ----------
    function items() {
      var n = total();
      var list = [];
      tiles.forEach(function (tile) {
        var q = qty(tile);
        if (q <= 0) return;
        var item = { id: parseInt(tile.getAttribute('data-variant-id'), 10), quantity: q };
        if (n > 1) { item.properties = {}; item.properties[PROPERTY_KEY] = '1'; }
        list.push(item);
      });
      if (n > 0) {
        accTiles.forEach(function (tile) {
          var q = qty(tile);
          if (q <= 0) return;
          var item = { id: parseInt(tile.getAttribute('data-variant-id'), 10), quantity: q, properties: {} };
          item.properties[ACC_PROPERTY_KEY] = '1';
          list.push(item);
        });
      }
      return list;
    }
    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || 'Något gick fel. Försök igen.';
      errEl.hidden = false;
    }
    function resetToInitial() {
      allTiles.forEach(function (t) { setQty(t, 0); });
      initialSelect();
      render();
    }
    function addToCart() {
      if (processing) return;
      var list = items();
      if (!list.length) return;
      processing = true;
      if (errEl) errEl.hidden = true;
      cta.classList.add('is-loading');
      cta.disabled = true;
      if (ctaLabel) ctaLabel.textContent = T.knappLaddar;
      var wantedSections = hasUpCart() ? 'cart-bubble' : 'cart-drawer,cart-bubble';
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: list, sections: wantedSections, sections_url: window.location.pathname })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error((e && (e.description || e.message)) || 'Cart add failed'); });
          return res.json();
        })
        .then(function (response) {
          try { root.dispatchEvent(new CustomEvent('svd:picker:added', { bubbles: true })); } catch (e) { /* svd-kontrakt */ }
          resetToInitial();
          if (hasUpCart()) {
            renderDrawerSections(response);
            tryOpenUpCart();
          } else if (document.getElementById('SvdNotis')) {
            /* SvdNotis-sektionen visar bekräftelsen (fångar /cart/add själv). */
          } else if (!openThemeCartDrawer(response)) {
            window.location.href = cartRoot + 'cart';
          }
        })
        .catch(function (err) {
          console.warn('[svd-slowfeeder] add-to-cart misslyckades', err);
          showError(err && err.message);
        })
        .finally(function () {
          processing = false;
          cta.classList.remove('is-loading');
          if (ctaLabel) ctaLabel.textContent = T.knapp;
          render();
        });
    }
    if (cta) cta.addEventListener('click', addToCart);

    // ---------- Startläge ----------
    // INGEN skål förvald (Eriks krav 2026-09-14): kunden gör första valet själv.
    // Räknaren visar "Välj din skål", knappen är avstängd tills något valts.
    function initialSelect() { /* avsiktligt tomt */ }
    initialSelect();
    render();
  }

  function mountAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-svd-slowfeeder]')).forEach(initPicker);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
  document.addEventListener('shopify:section:load', mountAll);
  /* svd-kontrakt (Claude 2026-09-25): montera väljare som injicerats i produktkortets
     "Lägg till"-blad (assets/svd-popup-quickadd.js) — bara rötter i e.detail.root. */
  document.addEventListener('svd:picker:mount', function (e) {
    var host = e && e.detail && e.detail.root;
    if (!host || !host.querySelectorAll) return;
    Array.prototype.forEach.call(host.querySelectorAll('[data-svd-slowfeeder]'), initPicker);
  });
})();
